<template>
  <form
    class="form"
  >
    <div class="form_flex_container">
      <!-- FIRST NAME -->
      <div class="custom-field" 
        :style="{ order: getOrder('firstName') }">
        <OneInput
                :brandClass="brandClass()"
          :profileStyle="true"
          v-model.trim="form.firstName" 
          :form="v$.form"     
          :label="$t('profile_name_label')+(isRequired('firstName') ? '*' : '')" 
          :paramName="'firstName'"
          :id="'firstName'"
          :tabindex="getOrder('firstName')"
          @blur="touchForm('firstName')"
          :errors="[
            {message:$t('profile_name_error_required'), thereIsTheError:v$.form.firstName.required.$invalid},
            {message:$t('profile_error_min_length_prefix')+getMinLength('firstName')+$t('profile_error_min_length_suffix'), thereIsTheError:v$.form.firstName.minLength.$invalid},
            {message:$t('profile_error_max_length_prefix')+getMaxLength('firstName')+$t('profile_error_max_length_suffix'), thereIsTheError:v$.form.firstName.maxLength.$invalid},
            {message:$t('generic_error_char_not_allowed'), thereIsTheError:v$.form.firstName.customRegexpValidation.$invalid},
          ]"
        />
      </div>
      <!-- LAST NAME -->
      <div class="custom-field" 
        :style="{ order: getOrder('lastName') }">
        <OneInput
                :brandClass="brandClass()"
          :profileStyle="true"
          v-model.trim="form.lastName" 
          :form="v$.form"     
          :label="$t('profile_surname_label')+(isRequired('lastName') ? '*' : '')" 
          :paramName="'lastName'"
          :id="'lastName'"
          :tabindex="getOrder('lastName')"
          @blur="touchForm('lastName')"
          :errors="[
            {message:$t('profile_surname_error_required'), thereIsTheError:v$.form.lastName.required.$invalid},
            {message:$t('profile_error_min_length_prefix')+getMinLength('lastName')+$t('profile_error_min_length_suffix'), thereIsTheError:v$.form.lastName.minLength.$invalid},
            {message:$t('profile_error_max_length_prefix')+getMaxLength('lastName')+$t('profile_error_max_length_suffix'), thereIsTheError:v$.form.lastName.maxLength.$invalid},
            {message:$t('generic_error_char_not_allowed'), thereIsTheError:v$.form.lastName.customRegexpValidation.$invalid},
          ]"
        />
      </div>
    </div>
  </form>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from "@vuelidate/validators";
import oneUtils from "../../gcdm-one-library/gcdm-one-utils/src/bootstrap";

export default {
  inject:['$c', '$t', 'brandClass'],
  setup() {
    return { v$: useVuelidate() }
  },
  name: "IntermediateRegistrationScreen",
  mixins: [oneUtils.customValidationMixin],
  props: [
    'title',
    'subtitle',
    'subsubtitle',
    'onSaveClicked',
    'user'
  ],

  data: () => ({
    form: {
      firstName: null,
      lastName: null,
    },
  }),
  validations: {
    form: {
      firstName: {
        minLength: function (value) {
          return this.isMinLengthValid("firstName", value);
        },
        maxLength: function (value) {
          return this.isMaxLengthValid("firstName", value);
        },
        required,
        customRegexpValidation: function (value) {
          return this.customRegexpValidation(value);
        },
      },
      lastName: {
        minLength: function (value) {
          return this.isMinLengthValid("lastName", value);
        },
        maxLength: function (value) {
          return this.isMaxLengthValid("lastName", value);
        },
        required,
        customRegexpValidation: function (value) {
          return this.customRegexpValidation(value);
        },
      }
    },
  },
  watch:{
    'v$.form': {
      deep: true,
      handler(newValue, oldValue) {
        this.$emit('formChanged', newValue)
      },
    },
  },
  computed: {
    sectionConfig() {
      return this.$c("_profileConfiguration").personalDataSection;
    },
    isButtonDisabled: function () {
      return this.v$.$invalid;
    }
  },
  mounted() {
    if(this.user.lastName){
      this.form.lastName = this.user.lastName;
      this.touchForm("lastName");
    }
    if(this.user.firstName){
      this.form.firstName = this.user.firstName;
      this.touchForm("firstName");
    }
  },
  methods:{
    closeAndLogout(){
      this.$emit('doLogout');
    },
    touchForm(fieldName) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      if (!this.v$.form) return;
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this.v$.form[fieldName].$touch();
    }
  }
};
</script>

<style lang="scss">



</style>
